/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deleteMachine = `mutation DeleteMachine($customer_id: String!, $id: String!) {
    deleteMachine(customer_id: $customer_id, id: $id)
  }
  `;
